import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, BellOff, Phone } from 'lucide-react';

export default function EmergencyOverlay({ emergency, onDismiss }) {
    // Sound effect
    useEffect(() => {
        let audioCtx;
        let oscillator;

        try {
            audioCtx = new (window.AudioContext || window.webkitAudioContext)();
            oscillator = audioCtx.createOscillator();
            const gainNode = audioCtx.createGain();

            oscillator.type = 'sawtooth';
            oscillator.frequency.setValueAtTime(500, audioCtx.currentTime);
            oscillator.frequency.linearRampToValueAtTime(1000, audioCtx.currentTime + 0.5);

            oscillator.connect(gainNode);
            gainNode.connect(audioCtx.destination);
            oscillator.start();

            // Loop effect
            const interval = setInterval(() => {
                const now = audioCtx.currentTime;
                oscillator.frequency.setValueAtTime(500, now);
                oscillator.frequency.linearRampToValueAtTime(1000, now + 0.5);
            }, 1000);

            return () => {
                oscillator.stop();
                clearInterval(interval);
                audioCtx.close();
            };
        } catch (e) {
            console.error('Audio error', e);
        }
    }, []);

    // Vibration
    useEffect(() => {
        if (navigator.vibrate) navigator.vibrate([200, 100, 200, 100, 500]);
    }, []);

    const sendSMS = () => {
        const ua = navigator.userAgent.toLowerCase();
        const msg = "🆘 ALERTA DE INUNDACIÓN. Necesito ayuda.";
        const url = (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1)
            ? `sms:&body=${encodeURIComponent(msg)}`
            : `sms:?body=${encodeURIComponent(msg)}`;
        window.open(url, '_blank');
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="emergency-overlay"
        >
            <motion.div
                animate={{ scale: [1, 1.1, 1] }}
                transition={{ repeat: Infinity, duration: 1 }}
                className="emergency-icon-container"
            >
                <AlertTriangle size={80} color="white" />
            </motion.div>

            <h1>¡ALERTA DE INUNDACIÓN!</h1>
            <p className="emergency-message">{emergency.message}</p>

            <div className="emergency-actions">
                <button onClick={onDismiss} className="btn-stop">
                    <BellOff /> Detener Alarma
                </button>
                <button onClick={sendSMS} className="btn-help">
                    <Phone /> Pedir Ayuda (SMS)
                </button>
            </div>
        </motion.div>
    );
}
